export var CONTACTS = [
  {
    id: 0,
    name: "\u0420\u0435\u0433\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u043F\u043E\u0440\u0442\u0438\u0432\u043D\u0430\u044F \u043E\u0431\u0449\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u0430\u044F \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F \xAB\u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u044F \u0442\u0440\u0438\u0430\u0442\u043B\u043E\u043D\u0430 \u0433\u043E\u0440\u043E\u0434\u0430 \u041C\u043E\u0441\u043A\u0432\u044B\xBB",
    short_name: "\u0420\u0421\u041E\u041E \xAB\u041C\u0424\u0422\xBB",
    address:
      "121552,\xA0\u0433\u043E\u0440\u043E\u0434 \u041C\u043E\u0441\u043A\u0432\u0430,\xA0\u041A\u0440\u044B\u043B\u0430\u0442\u0441\u043A\u0430\u044F \u0443\u043B., \u0434. 10 \u0441\u0442\u0440. 1",
    email: "moskva@rustriatlon.ru",
  },
];
